import { Button } from '@coolblue-development/becky';
import { datadogLogs } from '@datadog/browser-logs';
import { fetchContact } from '../../../../utils/fetchContact';
import { endConversation } from '../../../../utils/endConversation';

interface CloseEmailButtonProps {
  contactId: string;
}

const CloseEmailButton = ({ contactId }: CloseEmailButtonProps): JSX.Element => {
  const handleClose = (): void => {
    const contact = fetchContact(contactId);
    if (!contact) return;

    datadogLogs.logger.info('Close email button clicked', {
      contactId,
      contactStatus: contact.getStatus().type
    });

    endConversation(contact);
  };

  return (
    <Button
      data-testid="close-email-button"
      sx={{
        background: '#E50000',
        boxShadow: 'inset 0 -2px 0 #AA2222',
        ':hover': { background: '#BE0000', boxShadow: 'inset 0 -2px 0 #680B0F' }
      }}
      onClick={handleClose}
      size="small"
      fullWidth
    >
      Close email
    </Button>
  );
};

export default CloseEmailButton;
